import { ITodo, ITodoSchedule, schedule } from "../../types/interfaces";
import AppDatabase from "../InitialiseDatabase";
import LocalDataBase from "../InitialiseDatabase";
interface TodoObj {
  key: string,
  data: {
    title: string,
    description: string,
    priority:string,
  }
}
export default class ScheduleHandler{
  DB: AppDatabase;
  constructor() {
    this.DB = new AppDatabase()
  }

  CreateSchedule(title: string, description: string,
    todosArr: Array<ITodo>, scheduleDate: Date,project:string) {
    console.log(scheduleDate)
    const TodosSchedule = {
      title,
      description,
      todosArr,project,
      scheduleDate:new Date(scheduleDate).toLocaleString("en-us",{dateStyle:"long"})
    }
    this.DB.schedules.add(TodosSchedule)
  }

  async FetchSchedules(project: string) {
    const schedules = await this.DB.schedules.where("project").equals(project).toArray()
    return schedules
  }
  async FetchSchedule(filterKey:number) {
    let schedule = await this.DB.schedules.get(filterKey)
    
    return schedule
  }

    async EditSchedule(filterKey:number,editData:ITodoSchedule) {
      await this.DB.schedules.update(filterKey, {
      title: editData.title,
      description: editData.description,
      scheduleDate:new Date(editData.scheduleDate).toLocaleString("en-us",{dateStyle:"long"}) ,
      todosArr:editData.todosArr
    })
      
  }
  async DeleteSchedule(filterKey:number) {
    await this.DB.schedules.delete(filterKey)
  }
}
// export default class ScheduleHandler{
//   DB: any;
//   constructor() {
//     this.DB = LocalDataBase
//   }
//   CreateSchedule(title: string,
//     description: string,
//     todosArr: Array<TodoObj>,
//     scheduleDateTime: Date | string) {
//     console.log(scheduleDateTime)
//     const TodosSchedule = {
//       title,
//       description,
//       todosArr,
//       scheduleDateTime:new Date(scheduleDateTime).toLocaleString("en-us",{dateStyle:"long"})
//     }
//     this.DB.collection("todo-schedules").add(TodosSchedule)
//   }
//   async FetchSchedules() {
//     const schedules = await this.DB.collection("todo-schedules").get({ keys: true })
//     return schedules
//   }
//   async FetchSchedule(filterKeyString:string) {
//     let schedule = await this.DB.collection("todo-schedules").doc(filterKeyString).get()
    
//     return schedule
//   }
//   async EditSchedule(filterKeyString:String,editData:schedule) {
//     await this.DB.collection("todo-schedules").doc(filterKeyString).update({
//       title: editData.data.title,
//       description: editData.data.title,
//       scheduleDateTime:new Date(editData.data.scheduleDateTime).toLocaleString("en-us",{dateStyle:"long"}) ,
//       todosArr:editData.data.todosArr
//     })
//   }
//   async DeleteSchedule(filterKeyString:String) {
//     await this.DB.collection("todo-schedules").doc(filterKeyString).delete()
//   }
// }